export default {
    setting: {
        wholeNumMessage: "Must whole number",
        profileAuthSetting: "Profile Authentication Settings",
        logInOutSetting: "Login/Logout Settings",
        autoLogout: "Auto-Logout",
        unsuccessfulLoginAttempt: "Unsuccessful Login Attemps",
        unsuccessfulLoginLockPeriod: "Unsuccessful login Lock-out period",
        passCriteriaSetup: "Password Criteria Setup",
        passLength: "Password length",
        noUniquePassRequired: "Number of unique passwords required",
        maxPassAge: "Maximum password age",
        acceptableRangeOfChars: "Acceptable range of characters ",
        upperCase: "Upper case",
        lowerCase: "Lower case",
        numbers: "Numbers",
        specialChars: "Special characters",
        uniqueSymbols: "Unique symbols",
        loadingData: "Loading Data...",
        currency: "Currency",
        codeActivationTime: "Code Activation Time",
        changeGlobalSetting: "Change Global Settings",
        globalSetting: "Global Settings",
        generalSetting: "General Settings",
        hour: "Hours",
        days: "Days",
        minutes: "Minutes",
        perDay: "Per Day",
        perHour: "Per Hour",
        customised: "Customised",
        areaUnit: "Area Unit",
        weightUnit: "Weight Unit",
        minimumPwdLen: "Allowed minimum password length",
        otpPlaceholder: "Generate 6 digit OTP",
        generateOTP: "Generate OTP",
        smallFarm: "Small Farm",
        inclusive: "Inclusive",
        from: "From",
        to: "To",
        mediumFarm: "Medium Farm",
        largeFarm: "Large Farm",
        requiredMessage: "This field is required",
        nonNegativeMessage: "This field must be non negative",
        fieldToGreaterThanFrom: "This field should be greater than field 'From'",
        fieldToGreaterThanFromMedium:
          "This field should be greater than Small Farm field 'To'",
        fieldToGreaterThanMediumTo:
          "This field should be greater than Medium Farm field 'To'",

        farmSettings: "Farm Settings",
        profileSettings: "Profile Settings",
        enterpriseSettings: "Enterprise Settings",
        coffeeSettings: "Coffee Settings",
        cropVarietySettings: "Crop Variety Settings",
        cropVarietyName: "Crop Variety Name",
        cropType: "Crop Type",
        addCropVariety: "Add New Crop Variety",
        editCropVariety: "Edit Crop Variety",
        deleteCropVariety: "Delete Crop Variety",
        deleteCropVarietyConfirm: "Are you sure you want to delete this crop variety? This action cannot be undone.",
        cropVarietyDesc: "Manage crop varieties and their associated crop types for your organization.",
      },
}